<template>
  <div class="flex h-full flex-col text-slate">
    <div class="w-full rounded-t-lg">
      <div class="relative pt-[61.2%] md:pt-[56.5%]">
        <RichVideo
          v-if="isPlaying"
          :id="videoId"
          autoplay
          class="absolute inset-0"
          container-size
        ></RichVideo>

        <div
          v-else
          v-lazy-background="getAssetUrl(image)"
          class="absolute inset-0 flex items-center justify-center rounded-t-lg bg-cover"
        >
          <button
            v-if="videoId"
            aria-label="Play"
            class="play-btn flex h-12 w-12 cursor-pointer items-center justify-center rounded-full text-white backdrop-blur-xl"
            @click="playVideo"
          >
            <UiIcon icon="play"></UiIcon>
          </button>
        </div>
      </div>
    </div>

    <div class="flex-grow bg-white p-6">
      <UiSectionTitle
        v-if="title"
        :title="title"
        tag="h3"
        class="title mb-6 text-3xl uppercase leading-none text-slate"
      />

      <div v-if="features && features.length" class="mb-6 mt-auto flex gap-x-4">
        <div
          v-for="(feature, i) in features"
          :key="i"
          class="rounded-lg text-sm"
        >
          <div
            v-lazy-background="getAssetUrl(feature.iconMobile)"
            class="mb-2 h-8 w-8 bg-contain bg-left bg-no-repeat text-gray md:mb-4"
          ></div>

          <div
            class="max-w-[70px] text-[0.75rem] leading-4 opacity-60"
            v-html="feature.title"
          />
        </div>
      </div>

      <div
        v-if="featuresText"
        class="text-md leading-[1.8rem]"
        v-html="featuresText"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useMediaAsset } from '~/composables';

interface Props {
  image?: string;
  video?: string;
  videoId?: string;
  title?: string;
  text?: string;
  button?: any;
  features?: any[];
  featuresText?: string;
}

withDefaults(defineProps<Props>(), {
  image: '',
  video: '',
  videoId: '',
  title: '',
  text: '',
  button: () => ({}),
  features: () => [],
  featuresText: '',
});

const { getAssetUrl } = useMediaAsset();

const isPlaying = ref(false);

const playVideo = () => {
  isPlaying.value = true;
};
</script>

<style lang="sass" scoped>
.play-btn
  background: linear-gradient(180deg, rgba(126, 126, 126, 0.24) 0%, rgba(187, 187, 187, 0.16) 100%)
</style>
